import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ClubCard = ({ clubData, getClub }) => {

  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [type, setType] = useState('');
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [area, setArea] = useState('');
  const [division, setDivision] = useState('');
  const [district, setDistrict] = useState('');
  const [region, setRegion] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [linkedInVisible, setLinkedInVisible] = useState(false);
  const [facebook, setFacebook] = useState('');
  const [facebookVisible, setFacebookVisible] = useState(false);
  const [instagram, setInstagram] = useState('');
  const [instagramVisible, setInstagramVisible] = useState(false);
  const [x, setX] = useState('');
  const [xVisible, setXVisible] = useState(false);
  const [youtube, setYoutube] = useState('');
  const [youtubeVisible, setYoutubeVisible] = useState(false);

  const [isCollapsed, setIsCollapsed] = useState(true);

  useEffect(() => {
    if (clubData) {
      // console.log('clubData', clubData);
      setType(clubData.type || '');
      setName(clubData.name || '');
      setNumber(clubData.number || '');
      setArea(clubData.area || '');
      setDivision(clubData.division || '');
      setDistrict(clubData.district || '');
      setRegion(clubData.region || '');
      setLinkedIn(clubData.linkedIn || '');
      setLinkedInVisible(clubData.linkedInVisible || false);
      setFacebook(clubData.facebook || '');
      setFacebookVisible(clubData.facebookVisible || false);
      setInstagram(clubData.instagram || '');
      setInstagramVisible(clubData.instagramVisible || false);
      setX(clubData.x || '');
      setXVisible(clubData.xVisible || false);
      setYoutube(clubData.youtube || '');
      setYoutubeVisible(clubData.youtubeVisible || false);
    }
  }, [clubData]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const data = {
      "type": type,
      "name": name,
      "number": number,
      "area": area,
      "division": division,
      "district": district,
      "region": region,
      "linkedIn": linkedIn,
      "linkedInVisible": linkedInVisible,
      "facebook": facebook,
      "facebookVisible": facebookVisible,
      "instagram": instagram,
      "instagramVisible": instagramVisible,
      "x": x,
      "xVisible": xVisible,
      "youtube": youtube,
      "youtubeVisible": youtubeVisible,
    };

    // console.log('Data to be sent:', JSON.stringify(data, null, 2)); // Log the data being sent

    try {
      const response = await fetch(`${url}/club`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        // const result = await response.json();
        toast.success('Club updated successfully!', { position: 'bottom-left' });
        // console.log('Success:', result);
        getClub(); // Refresh the data
      } else {
        const errorResponse = await response.json();
        // console.error('Error response from server:', errorResponse);
        toast.error(`Failed to update Club! ${errorResponse.error || response.statusText}`, { position: 'bottom-left' });
      }
    } catch (error) {
      // console.error('Error updating Next Meeting:', error);
      toast.error(`Error updating Next Meeting! ${error.message}`, { position: 'bottom-left' });
    }
  },
    [type, name, number, area, division, district, region, linkedIn, linkedInVisible, facebook, facebookVisible, instagram, instagramVisible, x, xVisible, youtube, youtubeVisible, authUser.token, url, getClub]
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // Check if the active element is inside this card
        const cardElement = document.getElementById('club-card'); // Add a unique ID to the card
        if (cardElement && cardElement.contains(document.activeElement)) {
          handleSubmit(e); // Trigger handleSubmit only for this card
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <Card id='club-card' className="mb-3 mt-3">
      <Form data-bs-theme={'dark'}>
        <Card.Header onClick={toggleCollapse}>
          <Row className="header mb-2">
            <Col xs={11} lg={11} className="title">
              <h5>Club</h5>
            </Col>
            <Col xs={1} lg={1}>
              <i
                className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}
                style={{ cursor: 'pointer', paddingTop: '5px' }}
              ></i>
            </Col>
          </Row>
        </Card.Header>
        {!isCollapsed && (
          <>
            <Card.Body>
              <Form.Group className="mb-3">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Type"
                  className="formInput"
                  aria-label="Type"
                  name="type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  className="formInput"
                  aria-label="Name"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Number"
                  className="formInput"
                  aria-label="Number"
                  name="number"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Area</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Area"
                  className="formInput"
                  aria-label="Area"
                  name="area"
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Division</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Division"
                  className="formInput"
                  aria-label="Division"
                  name="division"
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>District</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="District"
                  className="formInput"
                  aria-label="District"
                  name="district"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Region</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Region"
                  className="formInput"
                  aria-label="Region"
                  name="region"
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="linkedInVisible"
                  label="Visible"
                  checked={linkedInVisible}
                  onChange={(e) => setLinkedInVisible(e.target.checked)}
                />
                <Form.Control
                  type="text"
                  placeholder="LinkedIn"
                  className="formInput"
                  aria-label="LinkedIn"
                  name="linkedIn"
                  value={linkedIn}
                  onChange={(e) => setLinkedIn(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Facebook</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="facebookVisible"
                  label="Visible"
                  checked={facebookVisible}
                  onChange={(e) => setFacebookVisible(e.target.checked)}
                />
                <Form.Control
                  type="text"
                  placeholder="Facebook"
                  className="formInput"
                  aria-label="Facebook"
                  name="facebook"
                  value={facebook}
                  onChange={(e) => setFacebook(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Instagram</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="instagramVisible"
                  label="Visible"
                  checked={instagramVisible}
                  onChange={(e) => setInstagramVisible(e.target.checked)}
                />
                <Form.Control
                  type="text"
                  placeholder="Instagram"
                  className="formInput"
                  aria-label="Instagram"
                  name="instagram"
                  value={instagram}
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>X</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="xVisible"
                  label="Visible"
                  checked={xVisible}
                  onChange={(e) => setXVisible(e.target.checked)}
                />
                <Form.Control
                  type="text"
                  placeholder="X"
                  className="formInput"
                  aria-label="X"
                  name="x"
                  value={x}
                  onChange={(e) => setX(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Youtube</Form.Label>
                <Form.Check
                  type="checkbox"
                  id="youtubeVisible"
                  label="Visible"
                  checked={youtubeVisible}
                  onChange={(e) => setYoutubeVisible(e.target.checked)}
                />
                <Form.Control
                  type="text"
                  placeholder="Youtube"
                  className="formInput"
                  aria-label="Youtube"
                  name="youtube"
                  value={youtube}
                  onChange={(e) => setYoutube(e.target.value)}
                />
              </Form.Group>
            </Card.Body>
            <Card.Footer>
              <Row className="mb-3">

                <Col xs={12} lg={12}>
                  <Button variant="primary" className="float-end" onClick={handleSubmit}>
                    <i className='bi bi-floppy'></i> Save
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </>
        )}
      </Form>
    </Card>
  );
};

export default ClubCard;